import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { useTheme } from '@rneui/themed'
import { AddMobileNumberScreen } from 'add_mobile_number/screen'
import { t } from 'app/i18l'
import { AppParamList } from 'app/types'
import { ComposeScreen } from 'chat/compose/screen'
import { AddMembersScreen } from 'chat/conversations/details/add_members'
import { EditConversationPropertyScreen } from 'chat/conversations/details/edit/screen'
import { ConversationDetailsScreen } from 'chat/conversations/details/screen'
import { CustomGroupStack } from 'chat/conversations/group/stack'
import { ConversationsTab } from 'chat/conversations/index'
import { SelectCompanyScreen } from 'chat/conversations/select_company'
import { RecipientsScreen } from 'chat/members/recipients/screen'
import { ChatGroupMembersScreen } from 'chat/members/screen'
import { PDFScreen } from 'chat/messages/file/pdf/screen'
import { FileScreen } from 'chat/messages/file/screen'
import { MentionsScreen } from 'chat/messages/mentions/screen'
import { ReactorsScreen } from 'chat/messages/reactors/screen'
import { ReadersScreen } from 'chat/messages/readers/screen'
import { MessagesScreen } from 'chat/messages/screen'
import { SearchMessagesScreen } from 'chat/messages/search/screen'
import { CrewListScreen } from 'crew_list/screen'
import { EventChangesScreen } from 'custom_events/changes/screen'
import { EditCustomEventScreen } from 'custom_events/screen'
import { ChatFileViewerScreen } from 'file_folder_repository/chat_file_viewer/screen'
import { AcknowledgeResourceScreen } from 'file_folder_repository/chat_group_folders/acknowledge_file_folder/screen'
import { FileAcknowledgementsScreen } from 'file_folder_repository/chat_group_folders/acknowledgements/file_acknowledgements/screen'
import { EditFileFolderScreen } from 'file_folder_repository/chat_group_folders/edit_file_folder/screen'
import { FileFolderSearchScreen } from 'file_folder_repository/chat_group_folders/file_folder_search/screen'
import { ShareResourceDetailsScreen } from 'file_folder_repository/chat_group_folders/send_file_folders/share_resource_details/screen'
import { ShareResourceRecipientsScreen } from 'file_folder_repository/chat_group_folders/send_file_folders/share_resource_recipients/screen'
import { FileFoldersBottomTab } from 'file_folder_repository/chat_group_folders/stack'
import { FileViewerScreen } from 'file_folder_repository/file_viewer/screen'
import { FreshchatScreen } from 'freshchat/screen'
import { AwardTransferGoldStarScreen } from 'gold_stars/screens/award_transfer_gold_star/screen'
import { GoldStarsScreen } from 'gold_stars/screens/gold_stars/screen'
import { StarRecipientsScreen } from 'gold_stars/screens/star_recipients/screen'
import { ViewGoldStarsTransactionsScreen } from 'gold_stars/screens/star_transactions/screen'
import { EditHolidayEventScreen } from 'holiday_events/screen'
import { HomeScreen } from 'home/screen'
import { NewUserPhoneNumberScreen } from 'management_team/add_member/new_observer_phone_number/screen'
import { AddEditUserScreen } from 'management_team/add_member/screen'
import { MemberChangesScreen } from 'management_team/member_changes/screen'
import { ManagementTeamScreen } from 'management_team/screen'
import { ObserverStoreChooserScreen } from 'management_team/store_chooser/screen'
import { TeamMemberScreen } from 'management_team/team_member/screen'
import { EditNonAvailabilityScreen } from 'non_availability/screens/add_non_availability/screen'
import { NonAvailabilityDetailsScreen } from 'non_availability/screens/non_availability_details/screen'
import { NonAvailabilityListScreen } from 'non_availability/screens/non_availability_list/screen'
import { NonAvailabilityRequestScreen } from 'non_availability/screens/non_availability_request/screen'
import { NotificationsScreen } from 'notifications/screen'
import { AuthScreen } from 'onboarding/screens/auth'
import React from 'react'
import { Platform } from 'react-native'
import { EditRequestTimeOffScreen } from 'request_time_off/screens/edit_time_off_request/screen'
import { TimeOffRequestListScreen } from 'request_time_off/screens/time_off_request_list/screen'
import { CrewMemberFilterScreen } from 'schedule/filters/crew_member/screen'
import { IncentivesFilterScreen } from 'schedule/filters/incentives/screen'
import { OpenShiftsPositionFilterScreen } from 'schedule/filters/position/open_shifts_screen'
import { PositionFilterScreen } from 'schedule/filters/position/screen'
import { SaveFilterScreen } from 'schedule/filters/save_filter/screen'
import { FilterChooserScreen } from 'schedule/filters/screen'
import { StartTimeFilterScreen } from 'schedule/filters/start_time/screen'
import { StoresFilterScreen } from 'schedule/filters/stores/screen'
import { ScheduleScreen } from 'schedule/screen'
import { PreferencesScreen } from 'settings/screens/preferences/screen'
import { SettingsScreen } from 'settings/screens/settings/screen'
import { SettingItemScreen } from 'settings/screens/settings/setting_item'
import { ShareAppScreen } from 'share_app/screen'
import { HeaderHomeBackButton } from 'shared/header/header_home_back_button'
import { CalloutCoverageScreen } from 'shifts/screens/call_out_coverage/screen'
import { CancelShiftScreen } from 'shifts/screens/cancel_shift/screen'
import { ConfirmShiftActionScreen } from 'shifts/screens/confirm_shift_action/screen'
import { EditCriticalShiftBonusScreen } from 'shifts/screens/edit_critical_shift_bonus/screen'
import {
  AddShiftScreen,
  EditShiftScreen,
} from 'shifts/screens/edit_shift/screen'
import { ShiftScreen } from 'shifts/screens/shift/screen'
import { SwapCoverShiftScreen } from 'shifts/screens/swap_cover_shift/screen'
import { StoreChooserScreen } from 'stores/screen'
import { TasksScreen } from 'tasks/screens/custom_tasks/screen'
import { EditRecurrentTaskScreen } from 'tasks/screens/edit_task/edit_recurrent_task/screen'
import { EditTaskScreen } from 'tasks/screens/edit_task/screen'
import { TaskDetailsPhotoViewerScreen } from 'tasks/screens/task_details/photo_viewer/screen'
import { TaskDetailsScreen } from 'tasks/screens/task_details/screen'
import { TaskUserListScreen } from 'tasks/screens/task_user_list/screen'
import { ToolsScreen } from 'tools/screens/tools'
import { CrewShiftsScreen } from 'user_shifts/screen'
import { DevToolsScreen } from 'users/account/dev_tools/screen'
import { EditUsernameScreen } from 'users/account/edit_username/screen'
import { AccountScreen } from 'users/account/screen'
import { AnytimeCrewMetricsScreen } from 'users/anytime_metrics/screen'
import { UserListScreen } from 'users/list/screen'
import { UserProfileScreen } from 'users/profile/screen'
import { WebScreen } from 'web/screen'
import { ScanQrCodeScreen } from 'web_login/screen'
import { PerformanceReportScreen } from '../../performance_reports/screen'
import { HomeStackParamList } from './types'

const Stack = createStackNavigator<HomeStackParamList>()

export function HomeStack({
  navigationRef,
}: {
  navigationRef: NavigationContainerRefWithCurrent<AppParamList>
}) {
  const { theme } = useTheme()

  return (
    <Stack.Navigator
      screenOptions={({ navigation }) => ({
        cardStyle: { backgroundColor: theme.colors?.white },
        headerTintColor: theme.colors?.primary,
        headerBackTruncatedTitle: t('back'),
        headerBackButtonDisplayMode: 'minimal',
        headerLeft: props => (
          <HeaderHomeBackButton
            navigation={navigation}
            theme={theme}
            navigationRef={navigationRef}
            {...props}
          />
        ),
        headerBackAllowFontScaling: false,
        headerTitleAllowFontScaling: false,
        headerTitleStyle: {
          width: '100%',
        },
        headerTitleAlign: 'left',
        headerMode: 'screen',
        animation: Platform.OS === 'web' ? 'default' : 'slide_from_right',
      })}
    >
      <Stack.Screen
        component={HomeScreen}
        name="home"
        options={() => ({
          title: t('home'),
        })}
      />
      <Stack.Screen
        component={ScheduleScreen}
        name="schedule"
        options={() => ({
          title: t('schedule'),
          headerBackButtonDisplayMode: 'minimal',
        })}
      />
      <Stack.Screen
        component={ScheduleScreen}
        name="open_shifts"
        options={() => ({
          title: t('schedule'),
          headerBackButtonDisplayMode: 'minimal',
        })}
      />
      <Stack.Screen
        component={ToolsScreen}
        name="tools"
        options={() => ({
          title: t('tools'),
        })}
      />
      <Stack.Screen
        component={AuthScreen}
        name="auth"
        options={() => ({
          headerShown: false,
        })}
      />
      <Stack.Screen
        component={PreferencesScreen}
        name="preferences"
        options={() => ({
          title: t('storePreferences'),
        })}
      />
      <Stack.Screen
        component={NotificationsScreen}
        name="notifications"
        options={() => ({
          title: t('notifications'),
        })}
      />
      <Stack.Screen
        component={ConversationsTab}
        name="conversations"
        options={() => ({
          title: t('messages'),
        })}
      />
      <Stack.Screen
        component={MessagesScreen}
        name="messages"
        options={() => ({
          title: t('messages'),
        })}
      />
      <Stack.Screen
        component={ReadersScreen}
        name="readers"
        options={() => ({
          title: t('readBy'),
        })}
      />
      <Stack.Screen
        component={ConversationDetailsScreen}
        name="conversation_details"
        options={() => ({
          title: t('details'),
          headerBackButtonDisplayMode: 'minimal',
        })}
      />

      <Stack.Screen
        component={AddMembersScreen}
        name="add_members"
        options={() => ({
          title: t('addMembers'),
        })}
      />

      <Stack.Screen
        component={ShiftScreen}
        name="shift"
        options={() => ({
          title: t('shift'),
        })}
      />
      <Stack.Screen
        component={CancelShiftScreen}
        name="cancel_shift"
        options={() => ({
          title: t('cancellation'),
        })}
      />
      <Stack.Screen
        component={AccountScreen}
        name="account"
        options={() => ({
          title: t('account'),
        })}
      />
      <Stack.Screen
        component={SettingsScreen}
        name="settings"
        options={() => ({
          title: t('settings'),
        })}
      />
      <Stack.Screen component={SettingItemScreen} name="setting_item" />
      <Stack.Screen
        component={CrewListScreen}
        name="crew_list"
        options={() => ({
          title: t('crewList'),
        })}
      />
      <Stack.Screen component={UserListScreen} name="user_list" />
      <Stack.Screen
        component={UserProfileScreen}
        name="user_profile"
        options={() => ({
          title: t('profile'),
        })}
      />
      <Stack.Screen
        component={AddMobileNumberScreen}
        name="add_mobile_number"
        options={() => ({
          title: t('addMobileNumber'),
        })}
      />
      <Stack.Screen component={CrewShiftsScreen} name="user_shifts" />
      <Stack.Screen
        component={SwapCoverShiftScreen}
        name="swap_cover_shift"
        options={() => ({
          title: t('details'),
        })}
      />
      <Stack.Screen
        component={SearchMessagesScreen}
        name="search_messages"
        options={() => ({
          title: t('searchMessages'),
        })}
      />
      <Stack.Screen
        component={DevToolsScreen}
        name="dev_tools"
        options={() => ({
          title: t('devTools'),
        })}
      />
      <Stack.Screen
        component={PDFScreen}
        name="pdf"
        options={() => ({
          title: '',
        })}
      />
      <Stack.Screen
        component={FileScreen}
        name="file"
        options={() => ({
          title: '',
        })}
      />
      <Stack.Screen
        component={CalloutCoverageScreen}
        name="call_out_coverage"
      />
      <Stack.Screen name="management_team" component={ManagementTeamScreen} />
      <Stack.Screen
        name="team_member"
        options={() => ({
          title: t('teamMember'),
        })}
        component={TeamMemberScreen}
      />
      <Stack.Screen
        name="new_user_phone_number"
        options={() => ({
          title: t('addTeamMember'),
        })}
        component={NewUserPhoneNumberScreen}
      />
      <Stack.Screen name="add_edit_user" component={AddEditUserScreen} />
      <Stack.Screen
        name="observer_store_chooser"
        options={() => ({
          title: t('chooseStores'),
        })}
        component={ObserverStoreChooserScreen}
      />
      <Stack.Screen
        name="member_changes"
        options={() => ({
          title: t('recentChanges'),
        })}
        component={MemberChangesScreen}
      />
      <Stack.Screen
        name="file_viewer"
        options={() => ({
          title: t('fileViewer'),
        })}
        component={FileViewerScreen}
      />
      <Stack.Screen
        name="chat_file_viewer"
        options={() => ({
          title: t('fileViewer'),
        })}
        component={ChatFileViewerScreen}
      />
      <Stack.Screen
        name="file_folder_search"
        options={() => ({
          title: t('fileFolderSearch'),
        })}
        component={FileFolderSearchScreen}
      />
      <Stack.Screen
        component={FileFoldersBottomTab}
        name="file_folders_bottom_tab"
      />
      <Stack.Screen
        name="event_changes"
        options={() => ({
          title: t('recentChanges'),
        })}
        component={EventChangesScreen}
      />
      <Stack.Screen
        component={ShareResourceRecipientsScreen}
        name="share_resource_recipients"
        options={() => ({
          title: 'Share',
        })}
      />
      <Stack.Screen
        component={ShareResourceDetailsScreen}
        name="share_resource_details"
      />
      <Stack.Screen
        component={AcknowledgeResourceScreen}
        name="acknowledge_resource"
        options={() => ({
          title: 'Acknowledge Resource',
        })}
      />
      <Stack.Screen
        component={NonAvailabilityListScreen}
        name="non_availability_list"
      />
      <Stack.Screen
        component={PerformanceReportScreen}
        name="performance_reports"
        options={() => ({
          title: t('performanceReports'),
        })}
      />
      <Stack.Screen component={GoldStarsScreen} name="gold_stars" />
      <Stack.Screen
        component={ViewGoldStarsTransactionsScreen}
        name="star_transactions"
      />
      <Stack.Screen
        name="file_acknowledgements"
        component={FileAcknowledgementsScreen}
        options={{ title: t('fileAcknowledgements') }}
      />
      <Stack.Screen
        component={TaskDetailsScreen}
        name="task_details"
        options={{ title: t('taskDetails') }}
      />
      <Stack.Screen component={TasksScreen} name="custom_tasks" />
      <Stack.Group screenOptions={{ presentation: 'modal' }}>
        <Stack.Screen
          name="chat_group_members"
          component={ChatGroupMembersScreen}
          options={() => ({
            title: t('members'),
          })}
        />
        <Stack.Screen
          name="edit_file_folder"
          component={EditFileFolderScreen}
        />
        <Stack.Screen
          component={StoreChooserScreen}
          name="store_chooser"
          options={() => ({
            title: t('stores'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={ReactorsScreen}
          name="reactors"
          options={({ route }) => ({
            headerLeft: () => null,
            title: route.params.emoji,
          })}
        />
        <Stack.Screen
          component={FilterChooserScreen}
          name="filter_chooser"
          options={() => ({
            title: t('filter'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={CustomGroupStack}
          name="custom_group_stack"
          options={() => ({
            headerShown: false,
          })}
        />
        <Stack.Screen
          component={SelectCompanyScreen}
          name="select_company"
          options={() => ({
            title: 'Select company',
          })}
        />
        <Stack.Screen
          component={RecipientsScreen}
          name="recipients"
          options={() => ({
            title: t('chooseRecipient'),
          })}
        />
        <Stack.Screen
          component={ComposeScreen}
          name="compose"
          options={() => ({
            title: t('newMessage'),
            animationTypeForReplace: 'pop',
            presentation: 'modal',
          })}
        />
        <Stack.Screen
          component={WebScreen}
          name="web"
          options={() => ({
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={EditConversationPropertyScreen}
          name="edit_conversation_property"
        />
        <Stack.Screen
          component={ConfirmShiftActionScreen}
          name="confirm_shift_action"
          options={() => ({
            title: t('confirmShiftAction'),
          })}
        />
        <Stack.Screen
          component={EditCriticalShiftBonusScreen}
          name="edit_critical_shift_bonus"
          options={() => ({
            title: t('editCriticalShiftBonus'),
          })}
        />
        <Stack.Screen component={StarRecipientsScreen} name="star_recipients" />
        <Stack.Screen
          component={AwardTransferGoldStarScreen}
          name="award_transfer_gold_star"
        />
        <Stack.Screen component={AddShiftScreen} name="add_shift" />
        <Stack.Screen component={EditShiftScreen} name="edit_shift" />
        <Stack.Screen
          component={EditCustomEventScreen}
          name="edit_custom_event"
        />
        <Stack.Screen component={EditTaskScreen} name="edit_task" />
        <Stack.Screen
          component={EditRecurrentTaskScreen}
          name="edit_recurrent_task"
        />
        <Stack.Screen
          component={TaskDetailsPhotoViewerScreen}
          name="task_details_photo_viewer"
        />
        <Stack.Screen component={TaskUserListScreen} name="task_user_list" />
        <Stack.Screen
          component={EditHolidayEventScreen}
          name="edit_holiday_event"
        />
        <Stack.Screen
          component={EditRequestTimeOffScreen}
          name="request_time_off"
        />
        <Stack.Screen
          component={EditNonAvailabilityScreen}
          name="edit_non_availability"
        />
        <Stack.Screen
          component={NonAvailabilityRequestScreen}
          name="non_availability_request"
        />
        <Stack.Screen
          component={NonAvailabilityDetailsScreen}
          name="non_availability_details"
        />
        <Stack.Screen
          component={TimeOffRequestListScreen}
          name="time_off_request_list"
        />
        <Stack.Screen
          component={PositionFilterScreen}
          name="position_filter"
          options={() => ({
            title: t('positions'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={OpenShiftsPositionFilterScreen}
          name="open_shifts_position_filter"
          options={() => ({
            title: t('positions'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={CrewMemberFilterScreen}
          name="crew_member_filter"
          options={() => ({
            title: t('crewMembers'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={IncentivesFilterScreen}
          name="incentives_filter"
          options={() => ({
            title: t('incentives'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={StartTimeFilterScreen}
          name="start_time_filter"
          options={() => ({
            title: t('startTime'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={StoresFilterScreen}
          name="stores_filter"
          options={() => ({
            title: t('stores'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={SaveFilterScreen}
          name="save_filter"
          options={() => ({
            title: t('saveFilter'),
            headerLeft: () => null,
          })}
        />
        <Stack.Screen
          component={EditUsernameScreen}
          name="edit_username"
          options={() => ({
            title: t('editUsernameAndPhoto'),
          })}
        />
        <Stack.Screen
          component={ShareAppScreen}
          name="share_app"
          options={() => ({
            title: t('shareNext'),
          })}
        />
        <Stack.Screen
          component={ScanQrCodeScreen}
          name="scan_qr"
          options={() => ({
            title: t('scanQr'),
          })}
        />
        <Stack.Screen component={MentionsScreen} name="mentions" />
        <Stack.Screen
          component={AnytimeCrewMetricsScreen}
          name="anytime_crew_metrics"
        />
        <Stack.Screen
          component={FreshchatScreen}
          name="freshchat"
          options={() => ({
            headerShown: false,
          })}
        />
      </Stack.Group>
    </Stack.Navigator>
  )
}
